import { render, staticRenderFns } from "./CreateOrderBtn.vue?vue&type=template&id=402174e1&scoped=true"
import script from "./CreateOrderBtn.vue?vue&type=script&lang=js"
export * from "./CreateOrderBtn.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderBtn.vue?vue&type=style&index=0&id=402174e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402174e1",
  null
  
)

export default component.exports